import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { adminApi, type Achievement } from '@/api';

export function AchievementsList() {
  const [items, setItems] = useState<Achievement[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    adminApi.achievements.list().then(setItems).catch((e) => setError(e.message)).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="text-slate-500">Loading…</div>;
  if (error) return <div className="text-red-600">{error}</div>;

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-semibold text-slate-800">Achievements</h1>
        <Link
          to="/achievements/new"
          className="rounded-lg bg-indigo-600 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-700"
        >
          Add achievement
        </Link>
      </div>
      <div className="rounded-xl border border-slate-200 bg-white overflow-hidden">
        <table className="min-w-full divide-y divide-slate-200">
          <thead className="bg-slate-50">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-medium text-slate-600 uppercase">Title</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-slate-600 uppercase">Requirement</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-slate-600 uppercase">Reward</th>
              <th className="px-4 py-3 text-right text-xs font-medium text-slate-600 uppercase">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-200">
            {items.map((a) => (
              <tr key={a.id}>
                <td className="px-4 py-3 text-slate-800 font-medium">{a.title}</td>
                <td className="px-4 py-3 text-slate-600">{a.requirement}</td>
                <td className="px-4 py-3 text-slate-600">{a.reward} XP</td>
                <td className="px-4 py-3 text-right">
                  <Link
                    to={`/achievements/${a.id}/edit`}
                    className="text-indigo-600 hover:underline text-sm font-medium"
                  >
                    Edit
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
